import React from 'react'
import { styled, Grid as BaseGrid } from '@mui/material'

export const Root = styled(({ children, inIframe, ...props }) => <div {...props}>{children}</div>)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100vh;
  padding: 0 0;
  width: 100%;
`

export const BaseContainer = styled(({ children, ...props }) => <div {...props}>{children}</div>)`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0 32px;
  width: 100%;

  ${props => props.theme.breakpoints.only('xs')} {
    max-width: 540px;
  }
  ${props => props.theme.breakpoints.only('sm')} {
    max-width: 720px;
  }
  ${props => props.theme.breakpoints.only('md')} {
    max-width: ${props => (props.inIframe ? '1140px' : '960px')};
  }
`

export const Header = styled('section')`
  margin: 0;
  width: 100%;

  ${props => props.theme.breakpoints.only('lg')} {
    margin: 0 auto;
    max-width: 1140px;
  }
  ${props => props.theme.breakpoints.only('xl')} {
    margin: 0 auto;
    max-width: 1140px;
  }
`

export const Footer = styled('section')`
  margin: 0;
  width: 100%;
`

export const Featured = styled('section')`
  margin: auto;
  width: 100%;

  ${props => props.theme.breakpoints.only('lg')} {
    max-width: 1140px;
  }
  ${props => props.theme.breakpoints.only('xl')} {
    max-width: 1140px;
  }
`

export const Body = styled(BaseGrid)`
  display: flex;
  height: auto;
  margin: 0 0 36px;
  padding: 14px 0 0;
  width: 100%;
`

export const Section = styled(BaseGrid)`
  margin: auto;

  ${props => props.theme.breakpoints.only('lg')} {
    max-width: 1140px;
  }
  ${props => props.theme.breakpoints.only('xl')} {
    max-width: 1140px;
  }
`
